import { Card } from "@mui/material";
import XButton from "../x-button";

export default function XDialogItemResolved(props: {
  title: string;
  subtitle: string;
  onClick: () => void;
  loading: boolean;
  variant?: "text" | "outlined" | "contained";
}) {
  return (
    <div className="flex flex-col w-full bg-white shadow">
      <div className="flex flex-col p-5">
        <span className="text-lg font-bold">{props?.title}</span>
        <span className="text-sm">{props?.subtitle}</span>
      </div>
      <div className="flex flex-row items-center justify-center gap-2 p-2">
        <XButton
          variant={props?.variant}
          loading={props?.loading}
          onClick={props?.onClick}
          name="Sim"
        />
      </div>
    </div>
  );
}
